import { Link } from "react-router-dom";
import NavbarDropdown from "./NavbarDropdown";

function Navbar() {
    const token = !!sessionStorage.getItem("token");
    return (<>
        <nav className="navbar navbar-expand-md" style={{ backgroundColor: "#712cf9" }}>
            <div className="container-fluid">
                {/* <a className="navbar-brand text-light" href="#">LOGO</a> */}
                <a className="navbar-brand text-light" href="#">
                    <img src="/assets/svg/logo1.png" alt="Brand Logo" style={{ height: "40px", width: "40px" }} />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    {token && <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link" to="/kc/orders">Orders</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/broker">Broker</Link>
                        </li>

                        <li className="nav-item dropdown d-flex align-items-center">
                            <NavbarDropdown />
                        </li>
                    </ul>}
                    {!token && <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link text-light" to="/login">Login</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link text-light" to="/registration">Register</Link>
                        </li>
                    </ul>}
                </div>
            </div>
        </nav>
    </>);
}

export default Navbar;
